import { cn } from "@/lib/utils";

/**
 * A pulsing placeholder the size of the text it stands in for. Inline, one
 * line high, so a value can be swapped for it without the layout moving.
 */
export const Skeleton = ({ className }: { className?: string }) => (
  <span
    aria-hidden
    className={cn(
      "inline-block h-[1em] w-12 rounded bg-neutral-700/60 align-middle animate-pulse",
      className,
    )}
  />
);
